var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded == false)?_c('waiting'):_vm._e(),(_vm.loaded)?_c('AppVersionForm',{attrs:{"item":_vm.item},on:{"modifyItem":_vm.modifyItem}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }